<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col sm="12" md="10" />
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ToolUptimeReportView",
  data() {
    return {
      labels: ['a', 'b'],
      datastuff: [{
        barPercentage: 0.5,
        barThickness: 6,
        maxBarThickness: 8,
        minBarLength: 2,
        data: [10, 20, 30, 40, 50, 60, 70]
      }]
    }
  }
}
</script>
